const MlbTestFeed = [
  {
    event: {
      home_score: 0,
      away_score: 0,
      type: 'match_started',
      description: 'Match Started',
      inning_half: 'T',
      outs: 0,
      inning: 1,
      home_hits: 0,
      away_hits: 0,
      is_live: true,
      count: {
        balls: 0,
        strikes: 0
      },
      runners: []
    }
  },
  {
    event: {
      home_score: 0,
      away_score: 1,
      type: 'score_change',
      description:
        'Francisco Alvarez doubles to left field. Brandon Nimmo to third. Mark Vientos scores.',
      inning_half: 'T',
      outs: 0,
      inning: 1,
      home_hits: 0,
      away_hits: 3,
      is_live: true,
      count: {
        balls: 5,
        strikes: 1
      },
      runners: [
        {
          starting_base: 1,
          ending_base: 1,
          out: false,
          full_name: 'José Azócar'
        }
      ]
    }
  },
  {
    event: {
      home_score: 0,
      away_score: 2,
      type: 'score_change',
      description:
        'Alan doubles to left field. Steve Nimmo to third. Utmost Vientos scores',
      inning_half: 'T',
      outs: 1,
      inning: 1,
      home_hits: 0,
      away_hits: 5,
      is_live: true,
      count: {
        balls: 6,
        strikes: 2
      },
      runners: [
        {
          starting_base: 1,
          ending_base: 2,
          out: false,
          full_name: 'José Azócar'
        },
        {
          starting_base: 0,
          ending_base: 1,
          out: false,
          full_name: 'player one'
        }
      ]
    }
  },
  {
    event: {
      home_score: 0,
      away_score: 2,
      type: 'period_end',
      description: 'Jacob Young strikes out swinging.',
      inning_half: 'T',
      outs: 1,
      inning: 1,
      home_hits: 0,
      away_hits: 6,
      is_live: true,
      count: {
        balls: 7,
        strikes: 3
      },
      runners: [
        {
          starting_base: 2,
          ending_base: 3,
          out: true,
          full_name: 'José Azócar'
        },
        {
          starting_base: 1,
          ending_base: 2,
          out: false,
          full_name: 'player one'
        },
        {
          starting_base: 0,
          ending_base: 1,
          out: false,
          full_name: 'player two'
        }
      ]
    }
  },
  {
    event: {
      home_score: 0,
      away_score: 2,
      type: 'period_start',
      inning_half: 'B',
      outs: 2,
      inning: 2,
      home_hits: 0,
      away_hits: 6,
      is_live: true,
      count: {
        balls: 8,
        strikes: 4
      },
      runners: [
        {
          starting_base: 2,
          ending_base: 3,
          out: false,
          full_name: 'player one'
        },
        {
          starting_base: 1,
          ending_base: 2,
          out: false,
          full_name: 'player two'
        }
      ]
    }
  },
  {
    event: {
      home_score: 3,
      away_score: 2,
      type: 'homerun',
      description:
        'Dane Myers homers to center field. Connor Norby scores. Eric Wagaman scores. Jes\u00fas S\u00e1nchez scores.',
      inning_half: 'B',
      outs: 2,
      inning: 5,
      home_hits: 3,
      away_hits: 6,
      is_live: true,
      count: {
        balls: 9,
        strikes: 5
      },
      runners: [
        {
          starting_base: 3,
          ending_base: 4,
          out: false,
          full_name: 'player one'
        },
        {
          starting_base: 2,
          ending_base: 3,
          out: false,
          full_name: 'player two'
        },
        {
          starting_base: 0,
          ending_base: 1,
          out: false,
          full_name: 'player three'
        }
      ]
    }
  },
  {
    event: {
      home_score: 3,
      away_score: 2,
      type: 'match_ended',
      description: 'Match End',
      inning_half: 'B',
      outs: 2,
      inning: 5,
      home_hits: 3,
      away_hits: 6,
      is_live: false,
      count: {
        balls: 10,
        strikes: 6
      },
      runners: [
        {
          starting_base: 4,
          ending_base: 4,
          out: false,
          full_name: 'player one'
        },
        {
          starting_base: 3,
          ending_base: 4,
          out: false,
          full_name: 'player two'
        },
        {
          starting_base: 1,
          ending_base: 2,
          out: false,
          full_name: 'player three'
        },
        {
          starting_base: 0,
          ending_base: 1,
          out: false,
          full_name: 'player four'
        }
      ]
    }
  }
]

export { MlbTestFeed }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/enum/MlbEventTestFeed.js